
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getDocumentSyncSettingsDtoFormGroup() {
return new FormGroup({
    enabled: new FormControl<boolean | undefined>(undefined),
    direction: new FormControl<string | undefined>(''),
    documentTypeIds: new FormControl<Array<number> | undefined>([]),
    documentSubtypeIds: new FormControl<Array<number> | undefined>([]),
    syncOnCreate: new FormControl<boolean | undefined>(undefined),
    syncOnUpdate: new FormControl<boolean | undefined>(undefined),
    includeFileContent: new FormControl<boolean | undefined>(undefined),
    autoSync: new FormControl<boolean | undefined>(undefined),
})
;
}
      